module.exports = "/_next/static/images/top_shintouki-5272d9a4558e045e1085806a07e8c455.jpg";